/**
 * InputLabel component styles
 */

export default {
  styleOverrides: {
    root: {
      backgroundColor: "white",
      padding: "0 4px",
      zIndex: 1,
      fontWeight: "400 !important",
      fontSize: "21px !important",
      color: "#000 !important",
    },
  },
};
